import {AppDispatch} from 'store/customer/storeSetup';
import {setHiddenWall} from 'components/customer/RoomPlanner/store/roomPlannerSlice';

export const setHiddenWallWithRetry = (
    dispatch: AppDispatch,
    hiddenWallValue: string,
    shouldAttempt: () => boolean = () => true,
    maxAttempts = 15,
    intervalMs = 150
) => {
    let attempts = 0;
    const intervalId = setInterval(() => {
        attempts += 1;

        if (shouldAttempt()) {
            // Toggle value to force subscribers to react even if the
            // final value is the same as the previous one.
            dispatch(setHiddenWall(null));
            dispatch(setHiddenWall(hiddenWallValue));
            clearInterval(intervalId);
        } else if (attempts >= maxAttempts) {
            clearInterval(intervalId);
        }
    }, intervalMs);

    return () => clearInterval(intervalId);
};
